const init = () => {

    const forms = document.querySelectorAll('.signUpForm');
    // Options to update
    const selectOptions = [{
            title: "North Austin",
            value: "North Austin Campus",
            programs: [{
                    title: "Cosmetology",
                    value: "Cosmetology"
                },
                {
                    title: "Esthetics",
                    value: "Esthetics"
                },
                {
                    title: "Nail Technology",
                    value: "Nail Technology"
                }
            ]
        },
        {
            title: "South Austin",
            value: "South Austin Campus",
            programs: [{
                    title: "Cosmetology",
                    value: "Cosmetology"
                },
                {
                    title: "Esthetics",
                    value: "Esthetics"
                },
                {
                    title: "Nail Technology",
                    value: "Nail Technology"
                }
            ]
        }
    ];

    // initialiser
    const initialise = () => {
        forms.forEach(form => {
            const location = form.querySelector('select[name="campus"]');
            const program = form.querySelector('[name="program"]');
            const schedule = form.querySelector('select[name="schedule"]');
            setupLocations(location); // Set up initial locations on load

            if(program.children.length) {
                location.addEventListener('change', () => {
                    setUpPrograms(location, program);
                });
                program.addEventListener('change', () => {
                    setUpSchedule(program, schedule);
                });
            } else {
                location.addEventListener('change', () => {
                    setUpSchedule(program, schedule);
                });
            }
        })
    }

    const setupLocations = (target) => {
        if (window.location.pathname === '/massage-therapy/') {
            const item = selectOptions.find((item) => item.title === 'North Austin');
            buildOption(target, item.title, item.value)
        } else {
            selectOptions.forEach(item => {
                buildOption(target, item.title, item.value)
            });
        }
    }

    const setUpPrograms = (selectValue, target) => {
        const defaultOption = buildDefaultOption('SELECT A PROGRAM');
        target.innerHTML = '';
        target.append(defaultOption);
        const targetLocation = selectOptions.filter(item => item.value === selectValue.value)
        targetLocation[0].programs.forEach(item => {
            buildOption(target, item.title, item.value)
        });
    }

    const setUpSchedule = (program, schedule) => {
        const defaultOption = buildDefaultOption('SELECT A SCHEDULE');
        schedule.innerHTML = '';
        schedule.append(defaultOption);
        if (program.value === 'Massage') {
            buildOption(schedule, 'Afternoon', 'Afternoon');
        } else if (program.value === 'Esthetics') {
            buildOption(schedule, 'Morning', 'Morning');
            buildOption(schedule, 'Afternoon', 'Afternoon');
            buildOption(schedule, 'Evening', 'Evening');
        } else if (program.value === 'Nail Technology') {
            buildOption(schedule, 'Morning', 'Morning');
        } else {
            buildOption(schedule, 'Afternoon', 'Afternoon');
            buildOption(schedule, 'Evening', 'Evening');
        }
    }

    // build out option element from arguments 
    const buildOption = (selectTarget, title, value) => {
        let option = document.createElement('option');
        option.text = title;
        option.value = value;
        selectTarget.append(option);
    }

    // Default option for programs when new location is selected
    const buildDefaultOption = (defaultText) => {
        let option = document.createElement('option');
        option.text = defaultText;
        option.value = '';
        option.setAttribute('disabled', true);
        option.setAttribute('selected', true);
        return option;
    }

    initialise();
}

function ready(init) {
    if (document.readyState != 'loading') {
        init();
    } else {
        document.addEventListener('DOMContentLoaded', init);
    }
}

ready(init);
